import { render, staticRenderFns } from "./EventHead.vue?vue&type=template&id=ad6821c4&scoped=true&"
import script from "./EventHead.vue?vue&type=script&lang=js&"
export * from "./EventHead.vue?vue&type=script&lang=js&"
import style0 from "./EventHead.vue?vue&type=style&index=0&id=ad6821c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6821c4",
  null
  
)

export default component.exports